import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {ActivatedRoute, Router} from '@angular/router';
import {first} from 'rxjs';
import {InstitutionService} from '../../../services/institution.service';
import {HttpErrorResponse} from '@angular/common/http';
import {CountryService} from '../../../../setting/services/location/country.service';
import {ManagerTypeService} from '../../../../setting/services/institution/manager-type.service';

@Component({
  selector: 'app-institution-edit',
  templateUrl: './institution-edit.component.html',
  styleUrls: ['./institution-edit.component.scss']
})
export class InstitutionEditComponent implements OnInit{

  institutionForm: FormGroup;
  managerTypes: any[] = [];
  managerTypeSelected: number | undefined;

  countries: any[] = [];
  countrySelected: number | undefined;

  saving = false;

  loadForm = true;

  public data: any;
  id: number;
  printInstitutionCode = '';
  printInstitutionName = '';

  defaultImg: string;
  isSubmitted = false;
  fileHad: File = null;
  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef[] = [];

  constructor(private fb: FormBuilder,
              private institutionService: InstitutionService,
              private countryService: CountryService,
              private managerTypeService: ManagerTypeService,
              private translate: TranslateService,
              private toastr: ToastrService,
              public route: Router,
              public router: ActivatedRoute
  ) {
    this.institutionForm = this.fb.group({
      code: ['', [Validators.required]],
      name: ['', [Validators.required]],
      email: ['', [Validators.email]],
      phone: ['', [Validators.required]],
      address: [''],
      website: [''],
      postalCode: [''],
      city: [''],
      region: [''],
      manager: [''],
      file: null,
      fileSource: null,
      managerType: [''],
      country: [''],
      isEnable: '',
    });

  }

  ngOnInit(): void {
    this.institutionForm.get('isEnable')?.setValue('1');
    this.id = this.router.snapshot.params.id;
    this.institutionForm.patchValue(this.data);
    this.findManagerTypes();
    this.findCountries();

    if (this.id){
      this.institutionService.get(this.id)
          .pipe(first())
          .subscribe(x => {
            console.log(x);
            // console.log(x.country['@id']);
            this.institutionForm.patchValue(x);
            this.managerTypeSelected = x.managerType ? x.managerType['@id'] : null;
            this.printInstitutionCode = x.code;
            this.printInstitutionName = x.name;
            this.defaultImg = x.picture;

            this.countrySelected = x.country ? x.country['@id'] : null;

            this.institutionForm.get('isEnable')?.setValue(x.isEnable ? '1' : '0');

            this.loadForm = false;

          } );
    }

  }

  get fc(): any {
    return this.institutionForm.controls;
  }

  onChange(event): void{
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      this.fileHad = inputElement.files[0];
      this.institutionForm.patchValue({fileSource: this.fileHad});
      console.log(this.fileHad.name);
      // this.defaultImg = this.baseUploadUrl + 'uploads/' + this.fileHad.name;
      const reader = new FileReader();
      // tslint:disable-next-line:no-shadowed-variable
      reader.onload = (event: any) => {
        this.defaultImg = event.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  onKey(event: any): void {
    this.printInstitutionCode = event.target.value;
  }

  onKey2(event: any): void {
    this.printInstitutionName = event.target.value;
  }

  onFormSubmit(): void{
    this.isSubmitted = true;
    // if (this.userForm.valid && this.fileHad && this.fileHad.name){
    if (this.institutionForm.valid){
      this.saving = true;
      if (this.id){
        console.log('hello maoll');

        const formData = new FormData();
        // console.log(this.institutionForm.get('fileSource')?.value.type);
        // console.log(this.institutionForm.get('firstname')?.value);
        formData.append('code', this.institutionForm.get('code')?.value);
        formData.append('name', this.institutionForm.get('name')?.value);
        formData.append('phone', this.institutionForm.get('phone')?.value);
        formData.append('email', this.institutionForm.get('email')?.value);

        formData.append('address', this.institutionForm.get('address')?.value);
        formData.append('website', this.institutionForm.get('website')?.value);
        formData.append('postalCode', this.institutionForm.get('postalCode')?.value);
        formData.append('city', this.institutionForm.get('city')?.value);
        formData.append('region', this.institutionForm.get('region')?.value);
        formData.append('manager', this.institutionForm.get('manager')?.value);
        formData.append('managerType', this.institutionForm.get('managerType')?.value);
        formData.append('country', this.institutionForm.get('country')?.value);

        formData.append('isEnable', this.institutionForm.get('isEnable')?.value);

        formData.append('file', this.institutionForm.get('fileSource')?.value);
        formData.append('fileName', this.institutionForm.get('fileSource')?.value?.name);
        formData.append('fileSize', this.institutionForm.get('fileSource')?.value?.size);
        formData.append('fileType', this.institutionForm.get('fileSource')?.value?.type);

        console.log(formData);

        this.institutionForm.get('isEnable')?.setValue(this.institutionForm.get('isEnable')?.value === '1');

        this.institutionService.edit(this.id, formData).subscribe({
          next: (val: any) => {
            this.toastr.success('Institution edit with success !', 'Success');
            this.route.navigate(['/security/institutions']);

          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            const errors: any[] = err;
            console.log(errors);

            if (errors){
              errors.forEach((v) => {
                if (v.propertyPath === 'code') {
                  this.institutionForm.get('code')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'name') {
                  this.institutionForm.get('name')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'phone') {
                  this.institutionForm.get('phone')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'email') {
                  this.institutionForm.get('email')?.setErrors({serverError: v.message});
                }

                this.saving = false;
              });
            }
            else {
              this.toastr.error(err['hydra:description'], 'Error');
              this.saving = false;
            }

          }
        });
      }

    }
  }

  findCountries() {
    this.countryService.getCollection().subscribe({
      next: (data: any) => {
        console.log(data['hydra:member']);
        this.countries = data['hydra:member'];
        if (this.countries){
          this.countries = this.countries.map((v) => {
            v.id = v['@id'];
            return v;
          });
        }
      },
      complete: () => this.findManagerTypes(),
      error: (error: HttpErrorResponse) => {
        this.findManagerTypes()
        console.log(error);
      }
    });
  }

  findManagerTypes() {
    this.managerTypeService.getCollection().subscribe({
      next: (data: any) => {
        console.log(data['hydra:member']);
        this.managerTypes = data['hydra:member'];
        if (this.managerTypes){
          this.managerTypes = this.managerTypes.map((v) => {
            v.id = v['@id'];
            return v;
          });
        }
      },
      //complete: () => this.findCountries(),
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }


}
